import { privilegeVehicleConstants } from '../constants/privilegeVehicleConstants';
import { authConstants } from '../constants/authConstants';

const createItem = (items, item) => {
  items.unshift(item);
  return items;
};
const updateItem = (items, item) => {
  const result = [];
  for (let i = 0; i < items.length; i++) {
    if (items[i].id !== item.id) {
      result.push(items[i]);
    } else {
      result.push(item);
    }
  }
  return result;
};
const initialState = {
  showFormModal: false,
  currentItem: {},
  meta: { per_page: 7, total: 0, current_page: 1 },
  items: []
};

export const privilegeVehicles = (state = initialState, action) => {
  switch (action.type) {
    // Get page
    case privilegeVehicleConstants.GET_VEHICLES:
      return {
        ...state,
        error: null,
        loading: true
      };
    case privilegeVehicleConstants.GET_VEHICLES_SUCCESS:
      return {
        ...state,
        error: null,
        loading: false,
        items: action.privilegeVehicles.data,
        meta: action.privilegeVehicles.meta
      };
    case privilegeVehicleConstants.GET_VEHICLES_FAILURE:
      return {
        ...state,
        loading: false,
        error: 'Не удалось загрузить список!'
      };
    case privilegeVehicleConstants.EXPORT_UPLOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        items: action.privilegeVehicles.data,
        meta: action.privilegeVehicles.meta
      };
    // Get all
    case privilegeVehicleConstants.GETALL_REQUEST:
      return {
        ...state,
        loading: true
      };
    case privilegeVehicleConstants.GETALL_SUCCESS:
      return {
        ...state,
        loading: false,
        items: action.privilegeVehicles.data
      };
    case privilegeVehicleConstants.GETALL_FAILURE:
      return {
        // error: action.error.toString()
        ...state,
        loading: false,
        error: 'Не удалось загрузить список!'
      };

    // Create
    case privilegeVehicleConstants.CREATE_SUCCESS:
      return {
        ...state,
        loading: false,
        items: createItem(state.items, action.privilegeVehicle),
        meta: {
          ...state.meta,
          total: state.meta.total + 1
        },
        showFormModal: false
      };

    // Update
    case privilegeVehicleConstants.UPDATE_SUCCESS:
      return {
        ...state,
        loading: false,
        items: updateItem(state.items, action.privilegeVehicle),
        showFormModal: false
      };

    // Delete
    case privilegeVehicleConstants.DELETE_REQUEST:
      return {
        ...state,
        items: state.items.map(privilegeVehicle =>
          privilegeVehicle.id === action.id
            ? { ...privilegeVehicle, deleting: true }
            : privilegeVehicle
        )
      };
    case privilegeVehicleConstants.DELETE_SUCCESS:
      // remove deleted HeaderMenu from state
      return {
        ...state,
        loading: false,
        items: state.items.filter(user => user.id !== action.id),
        meta: {
          ...state.meta,
          total: state.meta.total - 1
        }
      };
    case privilegeVehicleConstants.DELETE_FAILURE:
      // remove 'deleting:true' property and add 'deleteError:[error]' property to HeaderMenu
      return {
        ...state,
        loading: false,
        items: state.items.map(privilegeVehicle => {
          if (privilegeVehicle.id === action.id) {
            // make copy of HeaderMenu without 'deleting:true' property
            const { deleting, ...privilegeVehicleCopy } = privilegeVehicle;
            // return copy of HeaderMenu with 'deleteError:[error]' property
            return { ...privilegeVehicleCopy, deleteError: action.error };
          }

          return privilegeVehicle;
        })
      };

    // Get item
    case privilegeVehicleConstants.LOAD_REQUEST:
      return {
        ...state,
        loading: true
      };
    case privilegeVehicleConstants.LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        currentItem: action.privilegeVehicle.data
      };
    case privilegeVehicleConstants.LOAD_FAILURE:
      return {
        ...state,
        loading: false,
        error: 'Не удалось загрузить элемент!'
      };

    // form modal
    case privilegeVehicleConstants.FORM_MODAL_OPEN:
      return {
        ...state,
        showFormModal: true
      };
    case privilegeVehicleConstants.FORM_MODAL_CLOSE:
      return {
        ...state,
        showFormModal: false
      };
    case privilegeVehicleConstants.SET_CURRENT_ITEM:
      return {
        ...state,
        currentItem: action.item
      };
    case authConstants.LOGOUT:
      return initialState;

    default:
      return state;
  }
};
